/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_TypeInputs */

const en_cmd_type = /** @type {(inputs: Cmd_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change type`)
};

const de_cmd_type = /** @type {(inputs: Cmd_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ ändern`)
};

/**
* | output |
* | --- |
* | "Change type" |
*
* @param {Cmd_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_type = /** @type {((inputs?: Cmd_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_type(inputs)
	return en_cmd_type(inputs)
});